export default __webpack_public_path__ + "static/media/Kelli_Kedis_Ogborn_AHV_In_Moms_We_Trust.c3ce2f68.jpg";